import React from "react"
import styled from "styled-components"
import { Link as ScrollLink } from "react-scroll"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import {
  BasicImage,
  StyledHeading,
  BodyCopy,
  StandardContainer,
  CallToAction,
  SectionWrapper,
} from "../../common"

const StyledFeatures = styled.div`
  h2 {
    text-align: center;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
`

const FeaturesWrapper = styled(StandardContainer)`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => (props.centered ? "center" : "flex-start")};
  h2 {
    margin: 2rem 0;
    width: 100%;
  }
`

const StyledFeature = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 2rem;
  padding: 0 1rem;
  /*  */
  > .gatsby-image-wrapper,
  img {
    max-width: 100%;
    ${(props) =>
      props.$isIcon &&
      `
    width: 50%;
    max-width: 120px; 
    `}

    height: auto;
    margin: 0 auto 2rem;
  }
  > ${BodyCopy} {
    a {
      display: block;
      font-size: 1.2rem;
      margin-top: 1rem;
      color: ${(props) => props.color} !important;
    }
  }
  @media ${(props) => props.theme.breakpoints.ns} {
    width: 50%;
    padding: 0 3rem;
  }
  @media ${(props) => props.theme.breakpoints.large} {
    width: calc(100% / 3);
    padding: 0 3rem;
  }
`

const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  column-gap: 2rem;

  @media (min-width: 500px) {
    flex-direction: row;
  }
`

const FeatureLink = ({ type, text, target, link }) => {
  return (
    <>
      {type === "Anchor" && text && target ? (
        <ScrollLink to={target} smooth={true} duration={800} reversed>
          {text}
        </ScrollLink>
      ) : type === "Page" && text && link ? (
        <>
          {link?.link_type === "Document" ? (
            <AnchorLink
              to={`${target ? link?.url + "#" + target : link?.url}`}
              stripHash
            >
              {text}
            </AnchorLink>
          ) : (
            link?.link_type === "Web" && (
              <a href={link?.url} target="_blank" rel="noopener noreferrer">
                {text}
              </a>
            )
          )}
        </>
      ) : null}
      {link?.link_type === "Media" && (
        <>
          <a href={link?.url} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </>
      )}
    </>
  )
}
const Feature = ({
  feature_icon,
  feature_title,
  feature_description,
  feature_color,
  link,
  link_text,
  link_type,
  link_target,
  $isIcon,
}) => {
  return (
    <StyledFeature color={feature_color} $isIcon={$isIcon}>
      <BasicImage {...feature_icon} />
      <StyledHeading size="h3" color={feature_color} as="h3">
        {feature_title?.text}
      </StyledHeading>
      <BodyCopy>
        {feature_description?.text}
        <FeatureLink
          type={link_type}
          text={link_text}
          target={link_target}
          link={link}
        />
      </BodyCopy>
    </StyledFeature>
  )
}

export const Features = ({
  heading,
  items,
  link_type,
  link_text,
  link_target,
  page_link,
  align_content,
  image_display,
  anchor_id,
  block_background,
  link_colour,
  second_link,
  second_link_text,
  second_link_type,
  second_link_target,
  second_link_colour,
}) => {
  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledFeatures id={anchor_id}>
        <FeaturesWrapper $wrappedStandard centered={align_content === "center"}>
          <StyledHeading size="h2">{heading?.text}</StyledHeading>
          {items?.map((item, index) => (
            <Feature
              key={`feature-${index}`}
              {...item}
              $isIcon={image_display === "Icon"}
            />
          ))}
        </FeaturesWrapper>
        <StyledButtons>
          <CallToAction
            type={link_type}
            text={link_text}
            target={link_target}
            page={page_link}
            colour={link_colour}
          />
          <CallToAction
            type={second_link_type}
            text={second_link_text}
            target={second_link_target}
            page={second_link}
            colour={second_link_colour}
          />
        </StyledButtons>
      </StyledFeatures>
    </SectionWrapper>
  )
}
